import { renderToCanvas, decorateStory, render } from './chunk-UXHY756F.mjs';
export { setup } from './chunk-UXHY756F.mjs';
import { global } from '@storybook/global';
import { start } from '@storybook/preview-api';

var{window:globalWindow}=global;globalWindow.STORYBOOK_ENV="vue3";globalWindow.PLUGINS_SETUP_FUNCTIONS||=new Set;var RENDERER="vue3",api=start(renderToCanvas,{decorateStory,render}),storiesOf=(kind,m)=>api.clientApi.storiesOf(kind,m).addParameters({renderer:RENDERER}),configure=(...args)=>api.configure(RENDERER,...args),{forceReRender}=api,{raw}=api.clientApi;try{module?.hot?.decline&&module.hot.decline();}catch{}

export { configure, forceReRender, raw, storiesOf };
